module.exports = __webpack_public_path__ + "static/media/timelapse_19.64295d15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Kiosk/WoodburningView/timelapse_19.jpg
// module id = 977
// module chunks = 0